/**
 * Microsoft Clarity — session recordings and heatmaps.
 *
 * Gated by VITE_APP_CLARITY_PROJECT_ID: builds without it (local, e2e) never
 * load the Clarity script. Coexists with Sentry, PostHog and OTel.
 */
import Clarity from '@microsoft/clarity'

const projectId = import.meta.env.VITE_APP_CLARITY_PROJECT_ID || ''

let initialized = false

/** Loads the Clarity tag once; no-op when no project id is configured. */
export const initClarity = () => {
  if (!projectId || initialized) return
  Clarity.init(projectId)
  initialized = true
}

/**
 * Ties the current Clarity session to the signed-in user.
 *
 * User ids are only unique within a tenant database, so the custom id is
 * tenant-scoped. Clarity hashes it client-side; no name or email is sent.
 *
 * @param userId - tenant-local user id
 * @param tenant - tenant slug
 * @param userType - portal user type (school, student, parent, ...)
 */
export const identifyClarityUser = (userId: number | string, tenant: string, userType: string) => {
  if (!initialized) return
  Clarity.identify(`${tenant}:${userId}`)
  Clarity.setTag('tenant', tenant)
  Clarity.setTag('userType', userType)
}
